import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../../config/authConfig";
import { initializeMsalTokenService } from "../../utils/msalTokenService";

/**
 * Component props interface
 */
interface AuthProviderProps {
  children: React.ReactNode;
}

const msalInstance = new PublicClientApplication(msalConfig);

// Phase 1: Initialize token service for use outside React context (Redux thunks)
initializeMsalTokenService(msalInstance);

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  return (
    <MsalProvider instance={msalInstance}>
      {children}
    </MsalProvider>
  );
};

// Export msalInstance for direct access if needed
export { msalInstance };

export default AuthProvider;